import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * FinancesCustomerView class extends JetView to create a view for customer financial information.
 */
export default class FinancesCustomerView extends JetView {
    /**
     * Configures the layout and components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type
            height: 650, // Set height of the view
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set type for inner layout
                    rows: [
                        {
                            view: 'tabbar', // Create a tabbar component
                            localId: 'tabbar', // Local ID for tabbar
                            height: 43, // Set height of the tabbar
                            options: [
                                {
                                    id: 'customers.financial.informationFinancial', // ID for financial information tab
                                    value: _('Financiero'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersFinancialInformationFinancialMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-customersFinancialInformationFinancialMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.financial.bankAccounts', // ID for bank accounts tab
                                    value: _('Cuentas Bancarias'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersFinancialBankAccountsMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-customersFinancialBankAccountsMenu', // CSS class for styling
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tabbar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
